import styled, { css } from 'styled-components';

export const HeaderWrapper = styled.div`
  ${({ theme }) => css`
    cursor: default;
    display: flex;
    gap: 0.5em;
    align-items: center;

    h4 {
      color: ${theme.color.chatHeading};
      margin: 0;
      font-weight: ${theme.font.weight.regular};
    }

    .action-buttons {
      flex-grow: 1;
      display: flex;
      justify-content: flex-end;
    }

    .branding {
      margin-left: 8px;
      height: 0;
      align-self: end;
      position: relative;
    }
  `}
`;

export const BetaBadge = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.color.betaBadgeBG};
    border-radius: 2px;
    color: ${theme.color.betaBadge};
    text-transform: uppercase;
    font-weight: 580;
    font-size: 10px;
    letter-spacing: 1px;
    padding: 4px 5px;
  `}
`;